import { Card as MuiCard } from '@mui/material';
import styled from '@mui/material/styles/styled';

export const Card = styled(MuiCard)(() => ({
    borderRadius: 27,
    border: '1px solid #E9E9E9',
    background: '#FFF',
    boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
}));
